import React from "react";
import { formatRupiah } from "../lib/format";

/**
 * Panel harga acuan pangan PIHPS Bank Indonesia.
 * Dipakai bersama oleh Monitoring Komoditas dan Buat Pesanan agar tampilannya sama.
 */
export default function BIPricePanel({ prices }) {
  if (!prices || prices.length === 0) return null;

  return (
    <div className="kedan-card p-4 bg-white border border-slate-200" data-testid="bi-price-panel">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-blue-700">
            Harga Acuan Pangan Bank Indonesia Berdasarkan Harga Rata-Rata Jenis Pasar Pedagang Besar
          </div>
          <div className="text-[11px] text-slate-500 mt-0.5">
            Sinkronisasi data harga komoditas pangan dari portal PIHPS Bank Indonesia Prov. SUMUT (https://www.bi.go.id/hargapangan)
          </div>
        </div>
        {prices[0]?.updated_at && (
          <div className="text-[11px] text-slate-400 font-mono bg-slate-50 px-2 py-1 rounded border border-slate-100 shrink-0">
            Update Terakhir : {new Date(prices[0].updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" })}
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
        {prices.map((p, idx) => (
          <div key={idx} className="p-2 rounded bg-slate-50 border border-slate-100 hover:bg-slate-100/50 transition-colors flex flex-col justify-between">
            <span className="text-[11px] font-medium text-slate-700 truncate" title={p.commodity_name}>
              {p.commodity_name}
            </span>
            <div className="flex items-baseline justify-between mt-1">
              <span className="text-xs font-bold text-slate-900 font-mono">{formatRupiah(p.price)}</span>
              <span className="text-[9px] text-slate-400 font-mono">/{p.denomination || "kg"}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
